import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, NavLink, useLocation } from "react-router-dom";
import $ from "jquery";
import { API_BASE_URL } from "../utils/app_url";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";
import { NotificationManager } from "react-notifications";
import { SITE_NAME } from "../config/AppConfig";
import { useSiteData } from "../context/SiteDataContext";

const logo = require("./../assets/img/logo.png");
const whiteLogo = require("./../assets/img/logo.png");
const wishlist = require("./../assets/img/wishlist-icon1.svg").default;
const cart = require("./../assets/img/cart-icon.svg").default;
const userLogo = require("./../assets/img/user.svg").default;
const language = require("./../assets/img/language.svg").default;
const toggle = require("./../assets/img/menu-btn.svg").default;
const cross = require("./../assets/img/cross-icon.svg").default;
const passwordIcon = require("./../assets/img/password-icon.svg").default;
const megaMenuImg = require("./../assets/img/megaMenuImg.png");

const Header = (props) => {
  const { user, setUser, cartCount, setCartCount, searchTerm, setSearchTerm, sidebarOpenContext, setSidebarOpenContext } = useAuth();
  const { selectedLanguage, changeLanguage, langJson } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [forgotEmail, setForgotEmail] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [loginStatus, setLoginStatus] = useState("");
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [forgotPassSec, setForgotPassSec] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showAccountDropdown, setShowAccountDropdown] = useState(false);
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [showMobileAccountDropdown, setShowMobileAccountDropdown] = useState(false);
  const [showMobileLanguageDropdown, setShowMobileLanguageDropdown] = useState(false);
  const accountDropdownRef = useRef(null);
  const languageDropdownRef = useRef(null);

  const languageOptions = [
    { value: "en", label: langJson?.language_english || "English" },
    { value: "es", label: langJson?.language_spanish || "Spanish" },
    { value: "fr", label: langJson?.language_french || "French" },
    { value: "it", label: langJson?.language_italian || "Italian" },
    { value: "de", label: langJson?.language_german || "German" },
    { value: "ru", label: langJson?.language_russian || "Russian" },
    { value: "tr", label: langJson?.language_turkish || "Turkish" },
  ];

  const selectedLanguageLabel =
    languageOptions.find((option) => option.value === selectedLanguage)?.label || "English";

  const { categories, announcements } = useSiteData();

  // Announcements state
  const [currentAnnouncementIndex, setCurrentAnnouncementIndex] = useState(0);
  const [isAnnouncementFading, setIsAnnouncementFading] = useState(false);



  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    const newValue = type === "checkbox" ? checked : value;

    setFormData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formData.email) {
      setLoginStatus(langJson?.emailisrequired);
      // } else if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,3}$/.test(formData.email)) {
      //   setLoginStatus(langJson?.emailisnotvalid);
    } else if (!formData.password) {
      setLoginStatus(langJson?.passwordisrequired);
    } else {
      setLoginStatus("");
      setLoading(true);
      const form = new FormData();
      form.append("login", formData.email);
      form.append("password", formData.password);

      try {
        const response = await fetch(`${API_BASE_URL}users/login`, {
          method: "POST",
          body: form,
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          // Authentication successful, you can redirect the user or perform further actions
          // if (Number(responseData.data.status) === 1) {
          setLoginStatus(responseData.msg);
          fetchCartCount();
          localStorage.setItem("FFFUserData", JSON.stringify(responseData.data));
          setUser(responseData.data);
          if (responseData.data.role === "customer") {
            if (location.pathname === "/register" || location.pathname === "/shop-creation" || location.pathname === "/vendor-register") {
              navigate("/");
            } else {
              $(".loginPopup").removeClass("active");
            }
          } else if (responseData.data.role === "admin") {
            $(".loginPopup").removeClass("active");
            navigate("/admin-dashboard");
          } else {
            $(".loginPopup").removeClass("active");
            navigate("/dashboard");
          }
          // navigate("/");
          // } else {
          //   setLoginStatus(responseData.msg);
          // }
          setLoading(false);
        } else {
          // Authentication failed, display an error message
          setLoginStatus(responseData.msg);
          setLoading(false);
        }
      } catch (error) {
        NotificationManager.error(langJson?.somethingwentwronginserverpleasetryagain);
        console.error("Error during login:", error);
        setLoading(false);
      }
    }
  };

  const handleForgotPassSubmit = async (event) => {
    event.preventDefault();
    if (!forgotEmail) {
      setLoginStatus(langJson?.emailisrequired);
    } else if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,3}$/.test(forgotEmail)) {
      setLoginStatus(langJson?.emailisnotvalid);
    } else {
      setLoginStatus("");
      setLoading(true);
      const form = new FormData();
      form.append("email", forgotEmail);
      try {
        const response = await fetch(`${API_BASE_URL}users/forget-password`, {
          method: "POST",
          body: form,
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          // Authentication successful, you can redirect the user or perform further actions
          // if (Number(responseData.data.status) === 1) {
          setLoginStatus(responseData.msg);
          setForgotEmail("");
          setLoading(false);
        } else {
          // Authentication failed, display an error message
          setLoginStatus(responseData.msg);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error during login:", error);
        setLoading(false);
      }
    }
  };

  const onSearchClick = () => {
    if (!searchTerm) {
      NotificationManager.warning(langJson?.pleaseentersearchvalue);
    } else {
      navigate(`/search/${searchTerm}`);
    }
  };

  const fetchCartCount = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}cart/count`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setCartCount(parseInt(responseData.data));
      } else {
      }
    } catch (error) { }
  };

  const onSelectLanguage = (lang) => {
    localStorage.setItem("appLanguage", lang);
    changeLanguage(lang);
    setShowLanguageDropdown(false);
  };

  const onLogout = () => {
    localStorage.removeItem("FFFUserData");
    setUser(null);
    setShowAccountDropdown(false);
    setShowMobileAccountDropdown(false);
    navigate("/");
  };

  const closeMobileSidebar = () => {
    $(".menuSlide").removeClass("active");
    $("body").removeClass("bodyNoScroll");
  };

  useEffect(() => {

    $(".mobileBtn").click(() => {
      $(".navDiv").toggleClass("active");
    });
    $(".categoryLink").click(() => {
      $(".submenu").toggleClass("active");
    });

    $(document).off("click.megaMenuClose");

    $(document).on("click.megaMenuClose", function (e) {
      if (
        !$(e.target).closest(".newMegamenu").length &&
        !$(e.target).closest(".categoryLink").length
      ) {
        $(".newMegamenu").removeClass("active");
      }
    });

    $(".categoryLink").off("click").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(".newMegamenu").toggleClass("active");
    });

    $(".loginLink").click(() => {
      $(".loginPopup").addClass("active");
    });
    $(".crossBtn").click(() => {
      $(".loginPopup").removeClass("active");
    });
  }, []);

  useEffect(() => {
    fetchCartCount();
  }, [user]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (accountDropdownRef.current && !accountDropdownRef.current.contains(event.target)) {
        setShowAccountDropdown(false);
      }

      if (languageDropdownRef.current && !languageDropdownRef.current.contains(event.target)) {
        setShowLanguageDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (props?.openModal === true || props?.openModal === false) {
      $(".loginPopup").addClass("active");
    }
  }, [props?.openModal]);

  useEffect(() => {
    if (sidebarOpenContext) {
      $(".sidedBar").addClass("mobileOpen");
      $("body").addClass("bodyNoScroll");
    } else {
      $(".sidedBar").removeClass("mobileOpen");
      $("body").removeClass("bodyNoScroll");
    }
  }, [sidebarOpenContext]);

  // Announcement rotation effect
  useEffect(() => {
    if (announcements.length > 1) {
      const rotationInterval = setInterval(() => {
        // Start fade out
        setIsAnnouncementFading(true);

        // After fade out completes, change announcement and fade in
        setTimeout(() => {
          setCurrentAnnouncementIndex((prevIndex) =>
            (prevIndex + 1) % announcements.length
          );
          setIsAnnouncementFading(false);
        }, 500); // Half second for fade out

      }, 5000); // Change announcement every 5 seconds

      return () => clearInterval(rotationInterval);
    }
  }, [announcements.length]);

  const currentAnnouncement = announcements[currentAnnouncementIndex];
  const currentAnnouncementText =
    currentAnnouncement?.[selectedLanguage] || currentAnnouncement?.en || "";

  useEffect(() => {

    // =============================
    // REMOVE OLD EVENTS (VERY IMPORTANT)
    // =============================
    $(".mobNav").off("click");
    $(".menuSlide").off("click");
    $(document).off("click", ".navDivMobile .submenuLink > a");
    $(document).off("click", ".navDivMobile a");

    // =============================
    // OPEN MOBILE MENU
    // =============================
    $(".mobNav").on("click", function () {
      $(".menuSlide").addClass("active");
      $("body").addClass("bodyNoScroll");
    });

    // =============================
    // CLOSE WHEN CLICK OVERLAY
    // =============================
    $(".menuSlide").on("click", function (e) {
      if ($(e.target).hasClass("menuSlide")) {
        closeMobileMenu();
      }
    });

    // =============================
    // SUBMENU TOGGLE
    // =============================
    $(document).on("click", ".navDivMobile .submenuLink > a", function (e) {

      const parent = $(this).closest(".submenuLink");

      if (parent.find(".sub-submenu").length) {
        e.preventDefault();

        // close others (optional)
        $(".navDivMobile .submenuLink")
          .not(parent)
          .removeClass("open")
          .find(".sub-submenu")
          .slideUp(250);

        parent.toggleClass("open");

        parent
          .find(".sub-submenu")
          .stop(true, true)
          .slideToggle(250);
      }
    });

    // =============================
    // CLOSE MENU WHEN ANY LINK CLICKED
    // =============================
    $(document).on("click", ".navDivMobile .sub-submenu a", function () {
      closeMobileMenu();
    });



    function closeMobileMenu() {
      $(".menuSlide").removeClass("active");
      $("body").removeClass("bodyNoScroll");
    }

    $(".newMegamenu").removeClass("active");

  }, [location.pathname]);

  useEffect(() => {

    $(".menuSlide").removeClass("active");
    $("body").removeClass("bodyNoScroll");

    $(".navDivMobile .submenuLink").removeClass("open");
    $(".navDivMobile .sub-submenu").hide();

  }, [location.pathname]);



  useEffect(() => {

    let touchStartX = 0;
    let touchEndX = 0;

    // TOUCH START
    document.addEventListener("touchstart", function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, false);

    // TOUCH END
    document.addEventListener("touchend", function (e) {
      touchEndX = e.changedTouches[0].screenX;
      handleGesture();
    }, false);

    function handleGesture() {

      // 👉 SWIPE RIGHT (OPEN MENU)
      if (touchStartX < 40 && touchEndX - touchStartX > 80) {
        $(".menuSlide").addClass("active");
        $("body").addClass("bodyNoScroll");
      }

      // 👉 SWIPE LEFT (CLOSE MENU)
      if (touchStartX < 40 && touchEndX - touchStartX > 80) {
        $(".menuSlide").removeClass("active");
        $("body").removeClass("bodyNoScroll");
      }
    }

  }, []);



  return (
    <div>
      <div className="header headerNew">
        <div className="headerTop">
          {currentAnnouncementText ? (
            <p
              className={`announcement-text ${isAnnouncementFading ? 'fade-out' : 'fade-in'}`}
              dangerouslySetInnerHTML={{ __html: currentAnnouncementText }}
            />
          ) : null}
        </div>

        <div className="mobileHeader">
          <div className="mobileContainer">
            <div className="mobLeft">
              <div className="mobNav"></div>

              <div className="logo">
                <NavLink to="/dashboard">
                  <img src={logo} alt="" />
                </NavLink>
              </div>
            </div>
            <ul className="mobileRight">
              {/* {user ? ( */}
              <li className="topCart">
                <Link to="/cart">
                  <img src={cart} alt="" />
                  {cartCount ? <span>{cartCount}</span> : null}
                </Link>
              </li>
              {/* ) : null} */}

            </ul>
          </div>
          <div className="topMobSearch">
            {user?.role !== "vendor" && user?.role !== "admin" ? (
              <>
                <input type="text" value={searchTerm} name="" onChange={(e) => setSearchTerm(e.target.value)} />
                <button type="submit" onClick={() => onSearchClick()}>
                  {langJson?.search}
                </button>
              </>
            ) : null}
          </div>
        </div>

        <div className="menuSlide">
          <div className="menuSlideInner">
            <div className="mobtop">
              {user && (
                <h2>Hi, {user?.name}</h2>
              )}
            </div>

            <div className="navDivMobile">
              {!user && (
                <>
                  <div className="notLoggedMenu">
                    <div className="sideLogo">
                      <img src={whiteLogo} alt="" />
                    </div>
                    <ul>
                      <li className="logOutMenu">
                        <Link to="/register">{langJson?.signup_buy}</Link>
                      </li>
                      <li className="logOutMenu loginLink">
                        <a
                          href="javascript:void(0);"
                          onClick={() => {
                            closeMobileSidebar();
                            $(".loginPopup").addClass("active");
                          }}
                        >
                          {langJson?.signin}
                        </a>
                      </li>
                      
                    </ul>
                  </div>
                </>
              )}
              <ul>
                {/* {!user && (
                  <>
                    <li className="logOutMenu">
                      <Link to="/register">{langJson?.signup_buy}</Link>
                    </li>

                    <li className="logOutMenu loginLink">
                      <a
                        href="javascript:void(0);"
                        onClick={() => {
                          closeMobileSidebar();
                          $(".loginPopup").addClass("active");
                        }}
                      >
                        {langJson?.signin}
                      </a>
                    </li>

                    
                  </>
                )} */}


                {categories.map((category) => (
                  <li className="submenuLink" key={category.id}>
                    <NavLink to="">{langJson?.[category.slug] ?? category.title}{category.sub_categories?.length > 0 && (
                      <span className="chevArrow"></span>
                    )}</NavLink>
                    <ul className="sub-submenu">
                      {category.sub_categories.map((subCategory) => (
                        <li key={subCategory.id}>
                          <Link
                            to={{
                              pathname: `/shop/${subCategory.slug}`,
                            }}
                          >
                            {langJson?.[subCategory.slug] ?? subCategory.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}

                
                <li>
                  <NavLink to="/shop/bestsellers">{langJson?.bestsellers ?? "Bestsellers"}</NavLink>
                </li>
                <li>
                  <NavLink to="/shop/trending">{langJson?.trending ?? "Trending"}</NavLink>
                </li>
                <li>
                  <NavLink to="/shop/sale">{langJson?.sale}</NavLink>
                </li>
                
                <li>
                  <NavLink to="/about-us">{langJson?.aboutus}</NavLink>
                </li>
                
                
                
                <li>
                  <NavLink to="/contact-us">{langJson?.contactus}</NavLink>
                </li>

                {user && user?.role === "customer" ? (
                  <li className="mobileDropdownItem">
                    <button
                      type="button"
                      className="mobileDropdownToggle"
                      onClick={() => setShowMobileAccountDropdown(!showMobileAccountDropdown)}
                    >
                      {langJson?.myaccount || "Account"}
                      <span className={`chevArrow ${showMobileAccountDropdown ? "arrowOpen" : ""}`}></span>
                    </button>
                    {showMobileAccountDropdown ? (
                      <ul className="mobileDropdownList">
                        <li>
                          <Link to="/my-account" onClick={closeMobileSidebar}>{langJson?.myaccount}</Link>
                        </li>
                        <li>
                          <Link to="/my-orders" onClick={closeMobileSidebar}>{langJson?.myorders}</Link>
                        </li>
                        <li>
                          <Link to="/wishlist" onClick={closeMobileSidebar}>{langJson?.wishlist}</Link>
                        </li>
                        
                        <li>
                          <Link to="/shipping-address" onClick={closeMobileSidebar}>{langJson?.shippingaddress}</Link>
                        </li>
                        <li>
                          <a href="javascript:void(0);" onClick={() => { closeMobileSidebar(); onLogout(); }}>
                            {langJson?.logout}
                          </a>
                        </li>
                      </ul>
                    ) : null}
                  </li>
                ) : null}

                
                <hr></hr>

                {!user ? (
                  <>
                    <li>
                      <Link to="/register" onClick={closeMobileSidebar}>{langJson?.signup_buy}</Link>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        onClick={() => {
                          closeMobileSidebar();
                          $(".loginPopup").addClass("active");
                        }}
                      >
                        {langJson?.signin}
                      </a>
                    </li>
                    
                  </>
                ) : null}
              </ul>
            </div>
          </div>
        </div>

        <div className="mainDiv fullContainer desktopHeader">



          <div className="topHeader topHeaderNew">
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {user?.role === "vendor" && (
                <button className="sidebarToggle" onClick={() => setSidebarOpenContext(!sidebarOpenContext)} aria-label="Toggle sidebar">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 6H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <path d="M3 12H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <path d="M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </button>
              )}
              <div className="logo">
                <NavLink to="/">
                  <img src={logo} alt="" />
                </NavLink>
              </div>
            </div>

            <div className="navDiv">
              <ul>
                <li>
                  <NavLink to="" className="categoryLink">
                    {langJson?.categories}
                  </NavLink>
                  <div className="newMegamenu">
                    <div className="leftMegaMenu">
                      {categories.map((category) => (
                        <div className="submenuLink" key={category.id}>
                          <NavLink to="">{langJson?.[category.slug] ?? category.title}</NavLink>
                          <ul className="sub-submenuNew">
                            {category.sub_categories.map((subCategory) => (
                              <li key={subCategory.id}>
                                <Link
                                  to={{
                                    pathname: `/shop/${subCategory.slug}`,
                                  }}
                                >
                                  {langJson?.[subCategory.slug] ?? subCategory.title}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </div>
                    <div className="rightMegaMenu">
                      <img src={megaMenuImg} alt="" />
                    </div>
                  </div>
                  {/* <ul className="submenu">
                    {categories.map((category) => (
                      <li className="submenuLink" key={category.id}>
                        <NavLink to="">{langJson?.[category.slug] ?? category.title}</NavLink>
                        <ul className="sub-submenu">
                          {category.sub_categories.map((subCategory) => (
                            <li key={subCategory.id}>
                              <Link
                                to={{
                                  pathname: `/shop/${subCategory.slug}`,
                                }}
                              >
                                {langJson?.[subCategory.slug] ?? subCategory.title}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul> */}
                </li>
              </ul>
            </div>

            <div className="topSearch">
              {user?.role !== "vendor" && user?.role !== "admin" ? (
                <>
                  <input type="text" value={searchTerm} name="" onChange={(e) => setSearchTerm(e.target.value)} />
                  <button type="submit" onClick={() => onSearchClick()}>
                    {langJson?.search}
                  </button>
                </>
              ) : null}
            </div>
            <div className="topRight">
              <ul>
                
                {user && user?.role === "customer" ? (
                  <>
                    {/* <li>
                      <Link to={"/wishlist"}>
                        <img src={wishlist} alt="" />
                      </Link>
                    </li> */}
                    <li className="topCart">
                      <Link to="/cart">
                        <img src={cart} alt="" />
                        {cartCount ? <span>{cartCount}</span> : null}
                      </Link>
                    </li>
                    <li className="accountMenuLi" ref={accountDropdownRef}>
                      <button
                        type="button"
                        className="accountMenuBtn"
                        onClick={() => setShowAccountDropdown(!showAccountDropdown)}
                      >
                        <img src={userLogo} alt="" />
                      </button>
                      {showAccountDropdown ? (
                        <div className="accountDropdown">
                          <ul>
                            <li>
                              <Link to="/my-account" onClick={() => setShowAccountDropdown(false)}>{langJson?.myaccount}</Link>
                            </li>
                            <li>
                              <Link to="/my-orders" onClick={() => setShowAccountDropdown(false)}>{langJson?.myorders}</Link>
                            </li>
                            <li>
                              <Link to="/wishlist" onClick={() => setShowAccountDropdown(false)}>{langJson?.wishlist}</Link>
                            </li>
                            
                            <li>
                              <Link to="/shipping-address" onClick={() => setShowAccountDropdown(false)}>{langJson?.shippingaddress}</Link>
                            </li>
                            <li>
                              <a href="javascript:void(0);" onClick={() => onLogout()}>
                                {langJson?.logout}
                              </a>
                            </li>
                          </ul>
                        </div>
                      ) : null}
                    </li>
                  </>
                ) : (
                  <>
                    
                    <li className="guestAction">
                      <a
                        className="guestActionLink"
                        href="javascript:void(0);"
                        onClick={() => $(".loginPopup").addClass("active")}
                      >
                        {langJson?.signin}
                      </a>
                    </li>
                    <li className="guestAction guestActionPrimaryItem">
                      <Link to="/register" className="guestActionPrimaryLink">{langJson?.signup_buy}</Link>
                    </li>
                  </>
                )}
                {/* <li className="mobileBtn">
                  <img src={toggle} alt="image" />
                </li> */}
              </ul>
            </div>
          </div>

          <div className="navDiv newNavDiv">
            <ul>
              
              <li>
                <NavLink to="/shop/bestsellers">{langJson?.bestsellers ?? "Bestsellers"}</NavLink>
              </li>
              <li>
                <NavLink to="/shop/trending">{langJson?.trending ?? "Trending"}</NavLink>
              </li>
              <li className="text-fs-message-text-sale">
                <NavLink to="/shop/sale">{langJson?.sale}</NavLink>
              </li>
              
              <li>
                <NavLink to="/about-us">{langJson?.aboutus}</NavLink>
              </li>
              
              
              <li>
                <NavLink to="/contact-us">{langJson?.contactus}</NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>



      <div className="loginPopup">
        <div className="loginInner">
          {!forgotPassSec ? (
            <>
              <img src={cross} alt="" className="crossBtn" />
              <h2>{langJson?.login}</h2>

              <form onSubmit={handleSubmit}>
                <ul>
                  <li>
                    {/* <input type="text" name="email" placeholder={langJson?.emailormobileno} value={formData.email} onChange={handleChange} /> */}
                    <input type="text" name="email" placeholder={langJson?.email} value={formData.email} onChange={handleChange} />
                  </li>
                  <li>
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder={langJson?.password}
                    />
                    <div className="visibleClick" onClick={togglePasswordVisibility}>
                      <img src={passwordIcon} alt="Toggle Password Visibility" />
                    </div>
                    <NavLink onClick={() => setForgotPassSec(true)}>
                      {langJson?.didyouforgetyourpassword}
                    </NavLink>
                  </li>

                  <li>
                    <button type="submit" disabled={loading}>
                      {/* {loading ? langJson?.pleasewait : langJson?.signin} */}
                      {langJson?.signin}
                    </button>
                    <span className="lgnStatus">{loginStatus}</span>
                    {/* <NavLink to="/register" className="createBtn">
                      {langJson?.donthaveanaccount} {langJson?.createnow}
                    </NavLink> */}
                  </li>
                </ul>
              </form>
            </>
          ) : (
            <>
              <img src={cross} alt="" className="crossBtn" onClick={() => setForgotPassSec(false)} />
              <h2>{langJson?.forgotpassword}</h2>

              <form onSubmit={handleForgotPassSubmit}>
                <ul>
                  <li>
                    {/* <input type="text" name="email" placeholder={langJson?.emailormobileno} value={formData.email} onChange={handleChange} /> */}
                    <input type="text" name="email" placeholder={langJson?.email} value={forgotEmail} onChange={(e) => setForgotEmail(e.target.value)} />
                  </li>
                  <li></li>
                  <li>
                    <button type="submit" disabled={loading}>
                      {/* {loading ? langJson?.pleasewait : langJson?.signin} */}
                      {langJson?.continue}
                    </button>
                    <span className="lgnStatus">{loginStatus}</span>
                  </li>
                </ul>
              </form>
            </>
          )}

          {userData && (
            <div className="home">
              <h2>
                {langJson?.welcome}, {userData.name}!
              </h2>
              <p>
                {langJson?.email}: {userData.email}
              </p>
              <p>
                {langJson?.role}: {userData.role}
              </p>
              {/* Add more fields as needed */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
